module.exports = __webpack_public_path__ + "92c62def.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/icons/dealer/guarantee.svg
// module id = 2442
// module chunks = 0 22